class Tabs {
    constructor(tabContainer) {
        if (!tabContainer) {
            return;
        }

        this.tabContainer  = tabContainer;
        this.tabLinks      = this.tabContainer.querySelectorAll('[data-tab="button"]');
        this.tabContent    = this.tabContainer.querySelectorAll('[data-tab="content"]');
        this.tabSubLinks   = this.tabContainer.querySelectorAll('[data-sub-tab="button"]');
        this.tabSubContent = this.tabContainer.querySelectorAll('[data-sub-tab="content"]');

        if (this.tabLinks.length) {
            this.tabLinks.forEach((el) => {
                el.addEventListener('click', (e) => this.openTabs(e));
            });
        }

        if (this.tabSubLinks.length) {
            this.tabSubLinks.forEach((el) => {
                el.addEventListener('click', (e) => this.openTabsSub(e));
            });
        }
    }

    openTabs(el) {
        if (!this.tabContainer) return;

        const btnTarget = el.currentTarget;
        const item      = btnTarget.dataset.id;

        if (this.tabContent.length) {
            this.tabContent.forEach((el) => {
                el.classList.remove('is-active');
            });
        }

        if (this.tabLinks.length) {
            this.tabLinks.forEach((el) => {
                el.classList.remove('is-active');
            });
        }

        const targetElement = this.tabContainer.querySelector(`#${item}`);
        if (targetElement) {
            targetElement.classList.add('is-active');
        }

        if (btnTarget) {
            btnTarget.classList.add('is-active');
        }
    }

    openTabsSub(el) {
        if (!this.tabContainer) return;

        const btnTarget  = el.currentTarget;
        const item       = btnTarget.dataset.id;
        const unit       = btnTarget.parentElement;
        const unitBlocks = btnTarget.closest('[data-sub-tab="service"]');

        if (!unit || !unitBlocks) return;

        const unitLinks   = unit.querySelectorAll('[data-sub-tab="button"]');
        const unitContent = unitBlocks.querySelectorAll('[data-sub-tab="content"]');

        if (unitContent.length) {
            unitContent.forEach((el) => {
                el.classList.remove('is-active');
            });
        }

        if (unitLinks.length) {
            unitLinks.forEach((el) => {
                el.classList.remove('is-active');
            });
        }

        const targetElement = this.tabContainer.querySelector(`#${item}`);
        if (targetElement) {
            targetElement.classList.add('is-active');
        }

        if (btnTarget) {
            btnTarget.classList.add('is-active');
        }
    }
}

export default Tabs;
